import { useNavigate } from 'react-router-dom';
import type { WorkspaceStatus } from './types';
import './workspace-shell.css';

interface WorkspaceShellProps {
  title: string;
  status: WorkspaceStatus;
  children: React.ReactNode;
}

const STATUS_LABELS: Record<WorkspaceStatus, string> = {
  active: 'Disponible',
  shell: 'En construccion',
  future: 'Planificado',
};

/**
 * Layout base compartido para todos los workspaces.
 * Provee header con navegacion, badge de estado y slot de contenido.
 */
export function WorkspaceShell({ title, status, children }: WorkspaceShellProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="ws-layout">
      <header className="ws-header">
        <div className="ws-header-content">
          <div className="ws-header-left">
            <button className="ws-back-btn" onClick={() => navigate('/dashboard')} type="button">
              ← Dashboard
            </button>
            <div className="ws-header-divider" aria-hidden="true" />
            <h1 className="ws-header-title">{title}</h1>
          </div>
          <div className="ws-header-right">
            <span className={`ws-status-badge ws-status-badge--${status}`}>
              {STATUS_LABELS[status]}
            </span>
          </div>
        </div>
      </header>
      <main className="ws-main">{children}</main>
    </div>
  );
}
